/** Main-thread handle to the FEA worker (lazy singleton, Comlink RPC). */

import * as Comlink from 'comlink';

import type { FeaInput, FeaResult } from '@core/fea/hexSolver';
import type { FeaWorkerApi } from './fea.worker';

let worker: Comlink.Remote<FeaWorkerApi> | null = null;

function getWorker(): Comlink.Remote<FeaWorkerApi> {
  if (!worker) {
    worker = Comlink.wrap<FeaWorkerApi>(
      new Worker(new URL('./fea.worker.ts', import.meta.url), { type: 'module' }),
    );
  }
  return worker;
}

export async function runFeaSolve(
  input: Omit<FeaInput, 'onProgress'>,
  onProgress?: (phase: string, pct: number) => void,
): Promise<FeaResult> {
  // Clone mesh buffers — the originals are live in the viewport/evaluator.
  const positions = input.positions.slice();
  const indices = input.indices.slice();
  const triFaceIndex = input.triFaceIndex?.slice();
  const transfers: ArrayBuffer[] = [positions.buffer, indices.buffer];
  if (triFaceIndex) transfers.push(triFaceIndex.buffer);
  return getWorker().solve(
    Comlink.transfer({ ...input, positions, indices, triFaceIndex }, transfers),
    onProgress ? Comlink.proxy(onProgress) : undefined,
  );
}
